<template>
  <mdb-modal removeBackdrop size="md" :show="modalShow" @close="handleClose">
    <mdb-modal-header class="text-center" color="indigo">
      <mdb-modal-title tag="h4" bold class="w-100 text-white">{{
        $t("edit")
      }}</mdb-modal-title>
    </mdb-modal-header>
    <mdb-modal-body class="mx-3" color="white">
      <mdb-input
        :label="$t('subcategorytype_name')"
        type="text"
        v-model="subCategoryTypeName"
      />
      <mdb-input
        :label="$t('subcategorytype_description')"
        type="textarea"
        v-model="subCategoryTypeDescription"
      />
    </mdb-modal-body>
    <mdb-modal-footer center>
      <mdb-btn @click="saveEditSubCategoryType" color="indigo"
        >{{ $t("save") }}<mdb-icon icon="paper-plane" class="ml-1"
      /></mdb-btn>
    </mdb-modal-footer>
  </mdb-modal>
</template>

<script>
import {
  mdbBtn,
  mdbModal,
  mdbModalHeader,
  mdbModalBody,
  mdbInput,
  mdbModalFooter,
  mdbModalTitle,
  mdbIcon,
} from "mdbvue";
export default {
  name: "EditSubCategoryType",
  props: {
    modalShow: Boolean,
    addSubCategoryTypeState: Boolean,
    name: String,
    visible: Number,
    description: String,
    id: Number,
  },
  components: {
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbInput,
    mdbModalFooter,
    mdbModalTitle,
    mdbIcon,
  },
  data() {
    return {
      subCategoryTypePath: "/1.0/front/subcategorytypes",
      subCategoryTypeName: this.name,
      subCategoryTypeDescription: this.description,
    };
  },
  methods: {
    handleClose() {
      console.log("modal hide");
      this.$emit("modal-cancelled");
    },
    saveEditSubCategoryType() {
      this.postdata = JSON.stringify({
        sessionid: this.$store.getters.getToken,
        name: this.subCategoryTypeName,
        description: this.subCategoryTypeDescription,
        id: this.id,
        visible: this.visible,
      });
      this.$http
        .post(this.subCategoryTypePath, this.postdata)
        .then((response) => {
          if (response.status == 200) {
            this.$notify.success({
              message: this.$t("adding_subcategorytype_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort,
            });
          }
          this.$emit("modal-ok");
        })
        .catch((error) => {
          this.$notify.error({
            message: this.$t("adding_subcategorytype_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutshort,
          });
          this.$emit("modal-ok");
          console.log(error);
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped></style>
